import * as Yup from "yup";
import { Formik } from 'formik';

import {
    Grid,
    Dialog,
    TextField,
    Container,
    DialogTitle,
    IconButton,
    Card,
    CardContent,
    Divider
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { ActionButton } from "../../../utils/ui_utils";


function PurchaseOrderTypeDialog({
    initialValues,
    visible,
    title,
    onSubmit,
    onClose,
    okText,
}) {
    if (initialValues == undefined)
        initialValues = {
            short_name: '',
        };

    const validationSchema = Yup.object().shape({
        short_name: Yup.string().required("Required"),
    });

    const handleSubmit = async (
        values,
        { resetForm, setErrors, setStatus, setSubmitting }
    ) => {
        onSubmit(values);
    };

    return (
        <div>
            <Dialog maxWidth='xs' open={visible} aria-labelledby="form-dialog-title">
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card>
                                    <CardContent>
                                        <Grid container >
                                            <Grid item md={12}>
                                                <TextField
                                                    size="small"
                                                    name="short_name"
                                                    label="Short Name"
                                                    value={values.short_name}
                                                    error={Boolean(touched.short_name && errors.short_name)}
                                                    fullWidth
                                                    helperText={touched.short_name && errors.short_name}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item  >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </div>
    );

}

export default PurchaseOrderTypeDialog;